import {POLICIES} from "../constants/policies";

/**
 * Фора новичкам: живой игрок с рейтингом НИЖЕ этого порога получает
 * преимущество во всех партиях, кроме обучения и кампании (сетевых — обычных
 * и рейтинговых — и локальных):
 *  - отряды ботов (и помеченных значком, и остальных) и нейтральные отряды
 *    бросают против него кости урона со штрафом
 *    (LOW_RATING_ADVANTAGE_DAMAGE_DICE_FACE_PENALTY) — кроме бота с уровнем
 *    бонуса «божество», если в этом бою против него нет бота: тогда его кость
 *    всегда 0 (см. getLowRatingAdvantageDicePenalty, checkIfAnyOpponentIsBot);
 *  - боты в партии с таким игроком не покупают политики из
 *    LOW_RATING_ADVANTAGE_FORBIDDEN_BOT_POLICIES.
 *
 * Зеркало давления ботов на сильных игроков (configs/botPressure), только в
 * пользу человека.
 *
 * Признак ставится игроку один раз на старте партии и до ее конца не меняется
 * (player.hasLowRatingAdvantage): в сетевой партии — сервером по рейтингу
 * аккаунта, в локальной — клиентом по рейтингу вошедшего игрока (см.
 * checkIfLowRatingAdvantage). Обучение, кампания и демо признак не ставят, и
 * форы там нет.
 *
 * Порог совпадает с нижней границей Серебряной лиги, но задан числом: границы
 * лиг могут переехать, а фора — нет. Лиги в состоянии игрока вне рейтинговых
 * партий нет вовсе, и выдавать ее туда нельзя — по ней включается давление
 * ботов (см. applyBotPressureLatches).
 */
export const LOW_RATING_ADVANTAGE_RATING_THRESHOLD = 500;

/**
 * Штраф к ГРАНИ кости урона (не к значению d6): от выпавшей грани отнимается
 * столько, но меньше DAMAGE_DICE_MIN_VALUE (-3) грань не становится. Честная
 * кость {-3, -2, -1, -1, 0, 0} превращается в {-3, -3, -2, -2, -1, -1}: среднее
 * -2 вместо -7/6 (около -1,17), лучшая грань 0 не выпадает вовсе.
 *
 * Действует на каждую кость урона отряда бота или нейтрального отряда — в
 * ближнем бою, при стрельбе и при перебросе, — если среди противников отряда в
 * этом бою (или среди владельцев цели выстрела) есть игрок с форой. Поверх
 * подкруток бота: сначала пол и прибавка к d6, затем грань, затем штраф (см.
 * getDamageDiceRoll, getLowRatingAdvantageDicePenalty). Бота с «божеством»
 * (d6 всегда 6) штраф не касается, пока в этом бою против него нет бота: иначе
 * кости у него обычные, и штраф действует (см. checkIfAnyOpponentIsBot).
 */
export const LOW_RATING_ADVANTAGE_DAMAGE_DICE_FACE_PENALTY = 1;

/**
 * Политики, которые боты не покупают, пока в партии есть игрок с форой (см.
 * findBotPolicyToBuy). «Экоанархизм» — самая покупаемая политика у людей,
 * демонов и крысолюдов: проход сквозь пустые ячейки и снабжение на любое
 * расстояние новичку трудно предугадать.
 *
 * В раундах 1–5 «Экоанархизм» закрыт ботам в любой партии (см.
 * configs/botEarlyForbiddenPolicies) — этот список продлевает запрет против
 * новичка до конца партии. Запрет — на покупку: уже действующую политику из
 * списка бот из-за него не меняет.
 */
export const LOW_RATING_ADVANTAGE_FORBIDDEN_BOT_POLICIES = [POLICIES.ECOANARCHISM];
